module.exports = __webpack_public_path__ + "static/media/purevision.2140317a.png";